import React from 'react';
import summaryImage from './summary.jpg';

export const ObservationSummary = ({ height = 241 }: { height?: number }) => {
	return (
		<div>
			<img
				alt="summary"
				src={summaryImage}
				style={{ height: `${height}px` }}
			/>
		</div>
	);
};

export default ObservationSummary;
